import { InsuranceReportType } from "src/app/enum/insurance-report-type";

export class InsuranceReportRequest {
    public constructor() {
    }
    public startDate?: string;
    public endDate?: string;
    public insuranceId?: string;
    public insuranceName?: string;
    public insuranceReportType?: number;
}